function slugToTitleCaseES5(title) {
  return title
    .replace(/\//g, ' ')
    .replace(/-/g, ' ')
    .split(' ')
    .map(word => word.substring(0, 1)
      .toUpperCase()
      .concat(word.substring(1)))
    .join(' ')
    .trim();
}

module.exports.slugToTitleCaseES5 = slugToTitleCaseES5;
